import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface ActivitiesDropdownState {
    isOpen: boolean;
}

const initialState: ActivitiesDropdownState = {
    isOpen: false,
};

const activitiesDropdownSlice = createSlice({
    name: 'activitiesDropdown',
    initialState,
    reducers: {
        setActivitiesDropdown: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setActivitiesDropdown } = activitiesDropdownSlice.actions;
export const selectActivitiesDropdown = (state: RootState) =>
    state.activitiesDropdown.isOpen;
export default activitiesDropdownSlice.reducer;
